import { StringType } from '@convergence/types';
import { valueFromTreeAndPath } from './util';
import { AnalysisValueProps } from './types';
import { cva } from 'class-variance-authority';

const styles = cva([], {
  variants: {
    hasName: {
      true: 'pl-4',
      false: ''
    },
    hasValue: {
      true: '',
      false: 'italic text-gray-500'
    }
  }
});

export function AnalysisString(props: AnalysisValueProps<StringType>) {
  let value =
    valueFromTreeAndPath<string>(props.tree, props.propertyPath) ?? '';

  const name = props.name ? `${props.name}:` : '';

  return (
    <div className="py-2 border-l flex gap-2 w-full justify-between border-b-black border-b">
      <span className="">{name}</span>
      <p className={styles({ hasValue: !!value, hasName: !!name })}>
        {value ? value : '<None>'}
      </p>
    </div>
  );
}
